import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=7aaec64b&scoped=true"
import script from "./AvatarGroup.vue?vue&type=script&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaec64b",
  null
  
)

export default component.exports